// extracted by mini-css-extract-plugin
module.exports = {"folders-list":"folders-list_folders-list__3tNp-","selected":"folders-list_selected__3yHBQ","folders-list__folder":"folders-list_folders-list__folder__1BIvR"};